import React, { useState } from "react";
import Slider from "react-rangeslider";
import "react-rangeslider/lib/index.css";

export const StyleSlider = ({ onChange }) => {
    const [volume, setVolume] = useState(0);

    const handleOnChange = (value) => {
        setVolume(value);
        onChange(value);
    };

    return (
        <Slider
            value={volume}
            tooltip={false}
            orientation="horizontal"
            onChange={handleOnChange}
        />
    );
};
